// 📦 Import de React et des hooks nécessaires
import React, { useState, useEffect  } from "react";
import { Navigate } from "react-router-dom";
import InfosMap from "../components/InfosMap.js";
import QuotaInfo from "../components/QuotaInfo.js";
import { useGroupe } from "../context/GroupeContext.js";

// 📡 Import d'axios pour effectuer des requêtes HTTP
import axios from "axios";

// 🎨 Import des composants et hooks de Material-UI pour la mise en page et le style
import { Typography, Box ,Paper, useMediaQuery} from "@mui/material";
import { logDev } from "../utils/logger.js";
import { useLanguage } from '../context/LanguageContext.js';

const Infos = () => {
  const { t } = useLanguage();      // Hook de traduction

  const [headerHeight, setHeaderHeight] = useState(0);
  const [bottomNavHeight, setBottomNavHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);

  // 🎨 Récupération du thème MUI et détection si l'écran est mobile
  const isMobile = useMediaQuery("(max-width:600px)");

  // 📝 État pour stocker le nom du groupe connecté
  const { groupeId, nomGroupeComplet, couleur, reloadGroupeActif } = useGroupe();

  // --------------------
  // Gestion du rôle
  // --------------------
  const [role, setRole] = useState(null);
  const isAdmin = role === "admin";

  // Charger le rôle depuis la session
    useEffect(() => {
      const storedRole = sessionStorage.getItem("role");
      if (storedRole) {
        setRole(storedRole);
      }
    }, []);

    useEffect(() => {
  if (groupeId) reloadGroupeActif();
}, [groupeId]);

useEffect(() => {
  const header = document.querySelector('.header');
  const nav = document.querySelector('.MuiBottomNavigation-root');
  const footer = document.querySelector('.footer');

  const updateHeights = () => {
    if (header) setHeaderHeight(header.offsetHeight);
    if (nav) setBottomNavHeight(nav.offsetHeight);
    if (footer) setFooterHeight(footer.offsetHeight);
  };

  updateHeights();
  window.addEventListener("resize", updateHeights);
  return () => window.removeEventListener("resize", updateHeights);
}, []);

// 🔢 Calcul des offsets
const topOffset = headerHeight + (isMobile ? footerHeight : bottomNavHeight) + 16;
const bottomOffset = isMobile ? bottomNavHeight : footerHeight;

  if (!groupeId) return <Navigate to="/connexion" replace />;

  return (

<div 
className="infos-container"
  style={{
    minHeight: "100vh",
    paddingTop: `${topOffset}px`,
    paddingBottom: `${bottomOffset}px`,
    boxSizing: "border-box",
    backgroundColor: "#f4ece2",
    overflowY: "auto"
  }}
>
  {isAdmin && groupeId && (
          <QuotaInfo groupeId={groupeId} isAdmin={isAdmin} />
        )}
  <Paper
        elevation={1}
        sx={{
          backgroundColor: "#f4ece2",
          width: "90vw",
          padding: 2,
        }}
      >
        {/* 🔔 Notice rôle : message différent pour admin ou utilisateur */}
            <div
              style={{
                backgroundColor: "#2f2f2fff",
                padding: "12px 16px",
                borderRadius: "6px",
                marginBottom: "12px",
                fontSize: "1rem",
                fontWeight: "bold",
                textAlign: "center",
                color: "#fff",
                border: "2px solid #d4af37", // doré
                boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                backgroundImage: "radial-gradient(circle at top left, rgba(255,255,255,0.05), transparent 70%)"
              }}
            >
              {isAdmin
                ? t('InfosAdmin') 
                : t("InfosUsers")}
            </div>

        {/* 🏷️ En-tête avec le nom du groupe */}
        <Box 
          sx={{ 
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center", 
            marginBottom: 2 
          }}
        >
        <Typography
          variant="h6"
          align="center"
          gutterBottom
          sx={{
            color: couleur,
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            m: 0
          }}
        >
        <strong>{nomGroupeComplet}</strong>
        </Typography>
      </Box>
    <InfosMap />
  </Paper>
</div>
  );
};

export default Infos;
